"use strict";

/**
 * @file
 * Will provide responsive menu custom functionality.
 */
(function ($) {
    "use strict";

    Drupal.behaviors.custom_responsive_menu_mmenu = {
        attach: function (context) {
            $(document).ready(function(){
                let $btnMenu = $(context).find('#konvoy-nav-button');
                let $menu = $(context).find('#offcanvas-navigation');
                let $closeMenuBtn =  $(context).find('#nav-close-button');
                let contentBlurrable = $(document).find('.layout-content');
                $menu.mmenu({
                    slidingSubmenus: false,
                    extensions: [
                        'position-top',
                        "pagedim-black",
                        "theme-white"
                    ],
                    keyboardNavigation: {
                        enable: true,
                        enhance: true,
                    },
                    navbar : false,
                    offCanvas: {
                        position  : "top",
                        zposition : "front"
                    },
                    autoHeight: "true",
                    // drag: {
                    //     open: settings.drag
                    // }
                });
                var api = $($menu).data("mmenu");
                if ($(api).length > 0){
                    $($btnMenu).click(function() {
                        api.open();
                    });
                    $($closeMenuBtn).click(function() {
                        api.close();
                    });
                    $($menu).find( ".mm-next" ).addClass("mm-fullsubopen");
                    api.bind('open:after', function() {
                        $(contentBlurrable).delay(300).addClass('blurred-content');
                        $($btnMenu).removeClass('main-icon');
                        $($btnMenu).addClass('konvoy-nav-closed');
                    });
                    api.bind('close:after', function() {
                        $(contentBlurrable).removeClass('blurred-content');
                        $($btnMenu).removeClass('konvoy-nav-closed');
                        $($btnMenu).addClass('main-icon');
                    });
                }
            })
        }
    };
})(jQuery);
